import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '@guards/auth/auth.guard';
import { RoleGuard } from '@guards/role/role.guard';

import { PricingsComponent } from './pricings.component';
import { CreatePricingDialogComponent } from '@components/dialog/create-pricing-dialog/create-pricing-dialog.component';
import { EditPricingDialogComponent } from '@components/dialog/edit-pricing-dialog/edit-pricing-dialog.component';
import { DeletePricingDialogComponent } from '@components/dialog/delete-pricing-dialog/delete-pricing-dialog.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(
      [
        {
          path: 'pricings',
          component: PricingsComponent,
          canActivate: [AuthGuard, RoleGuard],
          data: {
            roles: ['Operator', 'Customer']
          },
          children: [
            {
              path: 'create',
              component: CreatePricingDialogComponent,
            },
            {
              path: 'edit/:key',
              component: EditPricingDialogComponent,
            },
            {
              path: 'delete/:key',
              component: DeletePricingDialogComponent,
            },
          ]
        },
      ]
    )
  ],
  providers: [
  ],
})
export class PricingsModule { }
